export enum SecurityNotificationType {
  PendingApproval = 1,
  SecurityApproved = 2,
  SecurityRejected = 3,
  SecurityDeleted = 4,
}
